import { observer } from 'mobx-react';
import { createParser, useQueryState } from 'nuqs';
import { Redirect } from 'react-router-dom';
import { isYmd } from '../../timeTracking/days';
import { useTimeTracking } from '../../timeTracking/useTimeTracking';
import { TimesheetDay } from './TimesheetDay';
import { TimesheetOverview } from './TimesheetOverview';

const dayParser = createParser({
	parse: (value: string) => (isYmd(value) ? value : null),
	serialize: (value: string) => value,
}).withOptions({ history: 'push' });

function _Timesheet() {
	const { enabled, canActAsSelf } = useTimeTracking();
	const [day, setDay] = useQueryState('day', dayParser);

	if (!enabled) {
		return <Redirect to='/' />;
	}

	return day ? (
		<TimesheetDay day={day} canActAsSelf={canActAsSelf} onBack={() => setDay(null)} />
	) : (
		<TimesheetOverview canActAsSelf={canActAsSelf} onOpenDay={setDay} />
	);
}

export const Timesheet = observer(_Timesheet);
